export default "__VITE_ASSET__G_2jNp$k__"